import { useServicePrimaryTagListQuery } from "entities/tagTypes/queries/useServicePrimaryTagListQuery";
import { xorBy } from "lodash";
import { useState, MouseEvent, useMemo } from "react";
import { FilterOption } from "shared/components/Filter";
import { useAnchorEl } from "shared/hooks/useAnchorEl";
import { FilterHook } from "../../../../../../types";

export const useTagTypeFilter = (): FilterHook => {
  const [selectedMultipleTagTypes, setSelectedMultipleTagTypes] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const { open, handleAnchorClose, handleAnchorOpen, anchorEl } = useAnchorEl();

  const { data: servicePrimaryTags = [], isFetching } =
    useServicePrimaryTagListQuery();

  const options = useMemo(
    () =>
      servicePrimaryTags.map((product) => ({
        label: product.name,
        value: product.id.toString(),
      })),
    [servicePrimaryTags],
  );

  const handleChangeValue = (
    _: MouseEvent<HTMLElement>,
    option: FilterOption,
  ) => {
    setSelectedMultipleTagTypes((prev) => xorBy(prev, [option], "value"));
  };

  const onClearSelectedValues = () => setSelectedMultipleTagTypes([]);

  return {
    filteredValues: selectedMultipleTagTypes.map((item) => item.value) ?? [],
    setFilteredValues: setSelectedMultipleTagTypes,
    filterData: {
      options,
      anchorEl,
      open,
      selectedValue: selectedMultipleTagTypes,
      handleOpenMenu: handleAnchorOpen,
      handleChangeValue,
      handleClose: handleAnchorClose,
      onClearSelectedValues,
    },
    isDisabledButton: isFetching,
  };
};
